import { render, staticRenderFns } from "./SVipBtn.vue?vue&type=template&id=6341c600&scoped=true&"
import script from "./SVipBtn.vue?vue&type=script&lang=js&"
export * from "./SVipBtn.vue?vue&type=script&lang=js&"
import style0 from "./SVipBtn.vue?vue&type=style&index=0&id=6341c600&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6341c600",
  null
  
)

export default component.exports